<div id="host">
  <app-toast-component></app-toast-component>
  <div class="header d-flex flex-row justify-content-between align-items-center">
    <div class="d-flex flex-row justify-content-between align-items-center">
      <h2>{{ 'security-policies-simulation-title' | translate }}</h2>
      <app-filters-sp (applyFilter)="filterByFilters($event)"></app-filters-sp>
    </div>
    <div class="action d-flex flex-row justify-content-end align-items-center">
      <app-form-add-policy-and-simulation (addPolicy)="addPolicies($event)" class="addpolicy"></app-form-add-policy-and-simulation>
      <app-form-add-policy-and-simulation [lallPolicies]="lSimulatePolicies"></app-form-add-policy-and-simulation>
    </div>
  </div>
  @if (!loadingOerror()) {
    <div class="d-flex flex-row align-items-start">
      @if (mapPolicies.size > 0) {
        <div class="canevasList d-flex flex-column">
          @for (item of mapPolicies | keyvalue: originalOrder; track item) {
            <div>              
              @if (item.value && item.value.length > 0) {
                @if(!this.keycloak.hasRealmRole('bo-dip-wl-admin')) {
                <div class="d-flex flex-row align-items-center head">
                  <img class="headimg" src="assets/icons/logosOS/{{ item.key }}.svg">
                  <h3 class="text-capitalize">{{ item.key }}</h3>
                </div>
                } @else {
                  <div class="d-flex flex-row align-items-center head">
                    <h3 class="text-capitalize">{{ item.key }}</h3>
                  </div>
                }
                @for (policy of item.value; track policy) {
                  <div type="button" class="d-flex flex-row justify-content-around align-items-center policy"
                    id="elem{{ supprEsp(policy.name.toLowerCase()) }}{{ policy.id }}"
                    (click)="policySelectionnee(policy); scroolTo()">
                    <div class="d-flex flex-column policnamebwv">
                      <h4 class="elemTitre">{{ policy.name }}</h4>
                      <h6>{{ policy.bwVersion?.version }}</h6>
                    </div>
                    <hr class="elemListehr">
                    @if (policy?.bwVersion) {
                      <img class="os" src="assets/icons/logosOS/{{ policy.bwVersion?.os?.toLowerCase() }}.svg">
                    }
                    <div class="d-flex flex-column date">
                      @if (policy.creationDate) {
                        <h4 class="elemTitre text-center">
                          {{ 'security-policies-simulation-creation-date' | translate }}
                        </h4>
                        <div class="d-flex flex-column text-center">
                          <h5>{{ timestampToDate(policy.creationDate) }}</h5>
                          <h6>{{ horaire(policy.creationDate) }}</h6>
                        </div>
                      }
                    </div>
                    <img class="side-arrow" src="assets/icons/ComprReport/down-arrow.svg">
                  </div>
                }
              }
            </div>
          }
          <app-form-add-policy-and-simulation (addPolicy)="addPolicies($event)" class="addpolicy"></app-form-add-policy-and-simulation>
        </div>
      } @else {
        <div class="d-flex flex-column">
          <app-loading-error [boolean]="false"
            [search]="'component-error-search-policies' | translate"
            [order]="'component-policies-simulate-search-order' | translate">
          </app-loading-error>
          <app-form-add-policy-and-simulation style="margin-top: 2.5%;" (addPolicy)="addPolicies($event)" class="addpolicy"></app-form-add-policy-and-simulation>
        </div>
      }
      <div id="policyInfos" hidden="hidden">
        <app-details-policy (editPtoMain)="editPolicy($event)" [type]="'simulation'" [policy]="currentpolicy"
          (deletePtoMain)="deleteP($event)" (submitPolicy)="submit($event)">
        </app-details-policy>
      </div>
    </div>
  } @else {
    @if (loadingOerror()) {
      <app-loading-error [boolean]="true" [message]="'waiting-for-policies' | translate">
      </app-loading-error>
    }
  }
</div>